import { render, staticRenderFns } from "./Our_story.vue?vue&type=template&id=202ebabb"
import script from "./Our_story.vue?vue&type=script&lang=js"
export * from "./Our_story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports